import { useAtomValue } from "jotai";
import { DropEvent, FileRejection, useDropzone } from "react-dropzone";

import { clientConfigAtom } from "atoms/clientConfig";

import { FILES_TO_ACCEPT, InputOptions } from "./constants";
import { useStyles } from "./styles";

type PhotoUploadProps = {
  children: JSX.Element;
  onDrop: <T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) => void;
  multiple?: boolean;
  disableGalleryUploadOverride?: boolean;
};

export const PhotoUpload = ({ children, onDrop, multiple = true, disableGalleryUploadOverride }: PhotoUploadProps) => {
  const { classes } = useStyles();

  const { disableGalleryUpload } = useAtomValue(clientConfigAtom);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: FILES_TO_ACCEPT,
    multiple,
  });

  const disabledUploadFromGallery = disableGalleryUploadOverride ?? disableGalleryUpload;

  const inputOptions: InputOptions = {
    capture: disabledUploadFromGallery ? "environment" : undefined,
    "aria-label": "Add photos",
  };

  return (
    <div {...getRootProps()} className={classes.uploadButtonContainer}>
      <input {...getInputProps(inputOptions)} />
      {children}
    </div>
  );
};
